import { Injectable } from '@angular/core';
import { RequestService } from '@app/core/request/request.service';
import { Observable } from 'rxjs';

@Injectable()
export class PhotosService {
    constructor(private request: RequestService) {}

    public getCorrespondencePhotos(dossier_volgnummer: number): Observable<any> {
        const payload = {
            dossier: {
                dossier_volgnummer: dossier_volgnummer,
            },
        };

        return this.request.post('schade-dossier/opvragen/correspondentiestuk-fotos', payload);
    }
}
